import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MailCheckIcon } from 'lucide-react';
import { AuthLayout } from '../../layouts/AuthLayout';
import { requestPasswordReset } from '../../services/authService';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  async function handleSubmit(event: React.FormEvent) {
    event.preventDefault();
    if (sending) return;
    setSending(true);
    setError(null);
    try {
      await requestPasswordReset(email);
      setSent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Inténtalo de nuevo.');
    } finally {
      setSending(false);
    }
  }
  return <AuthLayout title="Recuperar contraseña" subtitle="Te enviaremos un enlace para crear una contraseña nueva." footer={<Link to="/login" className="font-medium text-primary hover:underline" data-id="element-2015" data-mp="4sm7rzk72c74">
          Volver a iniciar sesión
        </Link>} data-id="element-2014" data-mp="2mgfxx5ra8sds">
      {sent ? <div className="rounded-lg border border-border bg-surface p-6 text-center" data-id="element-2016" data-mp="ek0g8wu4imce">
          <MailCheckIcon className="mx-auto mb-3 h-8 w-8 text-primary" aria-hidden="true" data-id="element-2017" data-mp="9l71l133opan" />
          <p className="text-sm text-foreground" data-id="element-2018" data-mp="9njjje8uyznp">
            Si existe una cuenta con <strong data-id="element-2019" data-mp="3i18xpfkxvk6l">{email}</strong>, recibirás un correo
            con el enlace de recuperación.
          </p>
        </div> : <form onSubmit={handleSubmit} className="space-y-5" noValidate data-id="element-2020" data-mp="3d48rn4o3ahfh">
          <Input id="email" label="Email" type="email" autoComplete="email" value={email} onChange={e => setEmail(e.target.value)} data-id="element-2021" data-mp="3r38blz0nq85b" />
          {error && <p role="alert" className="text-sm font-medium text-red-600" data-id="element-2022" data-mp="16b68kr3lrfr4">
              {error}
            </p>}
          <Button type="submit" size="lg" loading={sending} className="w-full" data-id="element-2023" data-mp="12ae0w2adpiwy">
            Enviar enlace
          </Button>
        </form>}
    </AuthLayout>;
}